/* hs-tg.js — «Підтвердь номер у Telegram» у кошику (HolyShape).
 *
 * Runs on the cart, next to the delivery picker (hs-np.js). When she presses
 * «Оформити замовлення»:
 *
 *   1. hs-np.js hands the checkout URL to window.HSTG.before() instead of
 *      going there itself. Without this file nothing changes on the cart.
 *   2. Half the carts (the PO system decides, so both halves are counted the
 *      same way) see a popup: her number → the bot → Telegram gives us the
 *      number of the account itself.
 *   3. The confirmed number is saved on the cart and passed to the checkout as
 *      checkout[shipping_address][phone]=+380…, so she does not type it twice.
 *      Shopify guesses the country from a bare number («+1 067…»), so it always
 *      goes in full international form.
 *   4. «Пізніше» closes the popup and goes to the checkout — it never blocks.
 *
 * The order side is the PO system's: an order whose phone equals the confirmed
 * one is confirmed on arrival, a different one goes through the old bot flow.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.HSTG = factory();
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var VERSION = 2;
  var API = 'https://returns.holyshapeua.com';
  var ATTRS = { token: '_tg_confirm', arm: '_tg_arm', cart: '_tg_cart', phone: '_tg_phone' };
  var ARM_WAIT_MS = 2500;      // the checkout is never held up longer than this
  var SAVE_WAIT_MS = 2000;     // nor longer than this for the cart write to land
  var POLL_MS = 2000;
  var LOOKUP_WAIT_MS = 1500;   // «Пізніше» checks once whether she already confirmed, never longer
  var POLL_FOR_MS = 10 * 60e3;

  // ── pure helpers (tested in test/hs-tg.test.js) ──────────────────────────
  // 9 digits, the way the PO system and Shopify both end up storing them.
  function digits9(v) {
    var d = String(v == null ? '' : v).replace(/\D/g, '');
    if (d.length > 9) d = d.slice(-9);
    return d.length === 9 ? d : null;
  }
  function intl(v) {
    var d = digits9(v);
    return d ? '+380' + d : null;
  }
  // What she sees while typing: «067 123 45 67» as written here, or «67 123 45 67»
  // when she leaves the 0 out. Nothing is thrown away — 10 digits at most.
  function pretty(v) {
    var d = String(v == null ? '' : v).replace(/\D/g, '');
    if (d.charAt(0) === '3' && d.length > 10) d = d.slice(-9);     // pasted 380…
    if (d.length > 10) d = d.slice(0, 10);
    var sizes = d.charAt(0) === '0' ? [3, 3, 2, 2] : [2, 3, 2, 2];
    var parts = [], at = 0;
    for (var i = 0; i < sizes.length && at < d.length; i += 1) { parts.push(d.substr(at, sizes[i])); at += sizes[i]; }
    if (at < d.length) parts.push(d.slice(at));
    return parts.join(' ');
  }
  // The cart token identifies the cart for both halves of the test; only the
  // last part of it travels, and never anything about her.
  function cartRef(token) {
    var t = String(token == null ? '' : token).replace(/[^A-Za-z0-9]/g, '');
    return t ? t.slice(0, 32) : '';
  }
  var PHONE_PARAM = /(checkout(?:%5B|\[)shipping_address(?:%5D|\])(?:%5B|\[)phone(?:%5D|\])=)[^&]*/;
  function withPhone(url, phone) {
    var p = intl(phone);
    if (!p) return url;
    var base = String(url || '/checkout');
    // Since the cart takes her number too (hs-np.js «Отримувачка»), the link
    // usually already carries one. A number confirmed in Telegram replaces it:
    // that one is verified, and it is the one the courier will ring.
    if (PHONE_PARAM.test(base)) return base.replace(PHONE_PARAM, '$1' + encodeURIComponent(p));
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'checkout[shipping_address][phone]=' + encodeURIComponent(p);
  }

  // «+380 67 111 22 33» — how a confirmed number is read back to her.
  function intlPretty(v) {
    var d = digits9(v);
    return d ? '+380 ' + pretty(d) : null;
  }

  var api = {
    VERSION: VERSION, ATTRS: ATTRS, digits9: digits9, intl: intl, intlPretty: intlPretty, pretty: pretty, cartRef: cartRef, withPhone: withPhone,
  };

  if (typeof document === 'undefined') return api;

  // ── browser ──────────────────────────────────────────────────────────────
  var doc = document, win = window;
  var state = { ref: '', arm: 'control', ask: false, test: false, token: null, phone: null, typed: null, bot: null, polling: null, saving: null };

  function post(path, body) {
    return fetch(API + path, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}),
    }).then(function (r) { return r.json(); });
  }
  function cartJson() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  // One look at a confirmation: the answer when the number is confirmed, null
  // otherwise (pending, unknown, or no network).
  function lookup(token) {
    return fetch(API + '/api/cart-confirm/status?token=' + encodeURIComponent(token))
      .then(function (r) { return r.json(); })
      .then(function (j) { return j && j.status === 'confirmed' && j.phone ? j : null; })
      .catch(function () { return null; });
  }
  // A cart written to while Shopify is creating the checkout out of it comes
  // back empty — she lands on the shop's front page with nothing in the cart
  // (owner, 2026-09-21: pressing «Оформити замовлення» the instant it appears).
  // So the write is remembered here and the checkout waits for it; keepalive
  // keeps it alive even when the page does go away first.
  function saveAttributes(attrs) {
    var p = fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', keepalive: true,
      body: JSON.stringify({ attributes: attrs }),
    }).catch(function () { /* the checkout matters more than the attribute */ });
    state.saving = p;
    p.then(function () { if (state.saving === p) state.saving = null; });
    return p;
  }

  // fn runs once the cart write has landed — and after SAVE_WAIT_MS whatever
  // happens, because a slow phone must never be left holding the checkout.
  function afterSave(fn) {
    var p = state.saving;
    if (!p) return fn();
    var done = false;
    var once = function () { if (done) return; done = true; fn(); };
    win.setTimeout(once, SAVE_WAIT_MS);
    p.then(once, once);
  }

  function el(tag, cls, text) {
    var n = doc.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  // The shop's own language, taken from the cart itself: brown ink #663e19 on
  // white, its field (46px, 8px radius, hairline brown border) and its button.
  // Nothing here is Telegram-blue — the cart stays HolyShape's.
  var CSS = '.hs-tg{--tg-ink:#663e19;--tg-line:rgba(102,62,25,.28);--tg-soft:rgba(102,62,25,.06);--tg-err:#a3261b}'
    + '.hs-tg__bd{position:fixed;inset:0;background:rgba(46,26,10,.55);display:flex;align-items:center;justify-content:center;padding:16px;z-index:2147483000;-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px)}'
    + '.hs-tg__w{--tg-ink:#663e19;--tg-line:rgba(102,62,25,.28);--tg-soft:rgba(102,62,25,.06);--tg-err:#a3261b;'
    + 'position:relative;box-sizing:border-box;background:#fff;color:var(--tg-ink);border:1px solid var(--tg-line);border-radius:16px;max-width:420px;width:100%;padding:22px 20px;'
    + 'box-shadow:0 24px 60px rgba(46,26,10,.28);font:400 15px/1.45 Helvetica,Arial,sans-serif;letter-spacing:normal;text-align:left;text-transform:none;max-height:92vh;overflow:auto}'
    + '.hs-tg__w *,.hs-tg__w *::before,.hs-tg__w *::after{box-sizing:border-box}'
    + '.hs-tg__h{font-size:19px;font-weight:700;line-height:1.25;margin:0 44px 8px 0;color:var(--tg-ink)}'
    + '.hs-tg__p{margin:0 0 14px;color:rgba(102,62,25,.78);font-size:14px;line-height:1.45}'
    + '.hs-tg__row{display:flex;align-items:stretch;gap:8px;margin:0 0 4px}'
    + '.hs-tg__pre{display:flex;align-items:center;padding:0 12px;border:1px solid var(--tg-line);border-radius:8px;background:var(--tg-soft);color:var(--tg-ink);font-weight:700;font-size:16px}'
    + '.hs-tg__in{flex:1;min-width:0;min-height:46px;border:1px solid rgba(102,62,25,.6);border-radius:8px;padding:10px 12px;font:inherit;font-size:16px;font-weight:400;color:var(--tg-ink);background:#fff;-webkit-appearance:none;appearance:none}'
    + '.hs-tg__in::placeholder{color:rgba(102,62,25,.55);opacity:1}'
    + '.hs-tg__in:focus{outline:2px solid var(--tg-ink);outline-offset:1px;border-color:var(--tg-ink)}'
    + '.hs-tg__in[aria-invalid="true"]{border-color:var(--tg-err)}'
    + '.hs-tg__err{color:var(--tg-err);font-weight:700;margin:6px 0 10px;min-height:18px;font-size:13px;line-height:1.35}'
    + '.hs-tg__err:empty{margin:0 0 12px;min-height:8px}'
    + '.hs-tg__b{display:block;width:100%;min-height:48px;padding:12px 16px;border-radius:10px;border:1px solid transparent;font:inherit;font-size:15px;font-weight:700;line-height:1.2;cursor:pointer;text-align:center}'
    + '.hs-tg__b:focus-visible{outline:2px solid var(--tg-ink);outline-offset:2px}'
    + '.hs-tg__x{position:absolute;top:6px;right:6px;width:44px;height:44px;display:flex;align-items:center;justify-content:center;border:0;background:none;color:rgba(102,62,25,.7);font:400 26px/1 Helvetica,Arial,sans-serif;cursor:pointer;border-radius:10px}'
    + '.hs-tg__x:hover{color:var(--tg-ink);background:var(--tg-soft)}'
    + '.hs-tg__x:focus-visible{outline:2px solid var(--tg-ink);outline-offset:2px}'
    + '.hs-tg__b--go{background:var(--tg-ink);color:#fff;margin:0 0 6px;text-decoration:none}'
    + '.hs-tg__b--go:hover{background:#52310f}'
    + '.hs-tg__b--go:disabled{opacity:.6;cursor:default}'
    + '.hs-tg__b--skip{background:transparent;color:rgba(102,62,25,.72);text-decoration:underline;text-underline-offset:2px;font-weight:400}'
    + '.hs-tg__b--skip:hover{color:var(--tg-ink)}'
    + '.hs-tg__note{display:flex;gap:8px;align-items:flex-start;background:var(--tg-soft);border:1px solid var(--tg-line);border-radius:10px;padding:10px 12px;margin:0 0 14px;font-size:13px;line-height:1.4;color:rgba(102,62,25,.8)}'
    + '.hs-tg__link{display:inline-block;margin:6px 0 0;padding:0;border:0;background:none;color:var(--tg-ink);font:inherit;font-size:13px;font-weight:700;text-decoration:underline;text-underline-offset:2px;cursor:pointer}'
    + '.hs-tg__note{display:block}'
    + '.hs-tg__ok{display:flex;align-items:center;gap:8px;font-size:20px;font-weight:700;color:var(--tg-ink);margin:0 0 12px;letter-spacing:.2px}'
    + '.hs-tg__tick{flex:none;display:flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:50%;background:var(--tg-ink);color:#fff;font-size:15px;font-weight:700}'
    + '.hs-tg__dots{display:flex;gap:5px;margin:0 0 14px}'
    + '.hs-tg__dot{width:7px;height:7px;border-radius:50%;background:var(--tg-line);animation:hs-tg-pulse 1.2s infinite}'
    + '.hs-tg__dot:nth-child(2){animation-delay:.2s}.hs-tg__dot:nth-child(3){animation-delay:.4s}'
    + '@keyframes hs-tg-pulse{0%,100%{background:var(--tg-line)}50%{background:var(--tg-ink)}}'
    + '@media (prefers-reduced-motion:reduce){.hs-tg__dot{animation:none}}'
    // On a phone it sits at the bottom, where her thumb already is.
    + '@media (max-width:480px){.hs-tg__bd{align-items:flex-end;padding:0}'
    + '.hs-tg__w{max-width:none;border-radius:18px 18px 0 0;border-bottom:0;padding:20px 16px calc(20px + env(safe-area-inset-bottom));max-height:88vh}}';

  function styles() {
    if (doc.getElementById('hs-tg-css')) return;
    var s = el('style');
    s.id = 'hs-tg-css';
    s.textContent = CSS;
    doc.head.appendChild(s);
  }

  // The popup. `done(phone)` continues to the checkout, with or without a number.
  function popup(done, onCancel) {
    styles();
    var bd = el('div', 'hs-tg__bd');
    var w = el('div', 'hs-tg__w');
    w.setAttribute('role', 'dialog');
    w.setAttribute('aria-modal', 'true');
    w.setAttribute('aria-labelledby', 'hs-tg-h');
    var h = el('h2', 'hs-tg__h', 'Підтвердь номер у Telegram');
    h.id = 'hs-tg-h';
    // A way out that looks like a way out; Escape and the backdrop do the same.
    var shut = el('button', 'hs-tg__x', '×');
    shut.type = 'button';
    shut.setAttribute('aria-label', 'Закрити й повернутись у кошик');
    var p = el('p', 'hs-tg__p', 'Так ми не телефонуємо зайвий раз, а замовлення одразу підтверджене. Номер підставимо в оформлення.');
    var note = el('div', 'hs-tg__note');
    note.appendChild(el('span', null, 'Замовляєш для іншої людини? Надішли їй посилання — вона підтвердить свій номер, і кур\'єр телефонуватиме саме їй.'));
    var share = el('button', 'hs-tg__link', 'Скопіювати посилання');
    share.type = 'button';
    var row = el('div', 'hs-tg__row');
    var pre = el('span', 'hs-tg__pre', '+380');
    var input = el('input', 'hs-tg__in');
    input.type = 'tel';
    input.inputMode = 'numeric';
    input.autocomplete = 'tel-national';
    input.placeholder = '067 123 45 67';
    input.setAttribute('aria-label', 'Номер телефону');
    row.appendChild(pre); row.appendChild(input);
    var err = el('p', 'hs-tg__err', '');
    err.setAttribute('role', 'alert');
    var go = el('button', 'hs-tg__b hs-tg__b--go', 'Підтвердити в Telegram');
    go.type = 'button';
    var skip = el('button', 'hs-tg__b hs-tg__b--skip', 'Пізніше, оформити замовлення');
    skip.type = 'button';
    note.appendChild(share);
    w.appendChild(shut); w.appendChild(h); w.appendChild(p); w.appendChild(row); w.appendChild(err); w.appendChild(go); w.appendChild(skip); w.appendChild(note);
    bd.appendChild(w);
    doc.body.appendChild(bd);
    // What she already typed in the cart. She confirms it with one tap;
    // correcting it is still one tap into the field.
    if (state.typed) {
      input.value = pretty(state.typed);
      p.textContent = 'Це номер, який ти вказала в кошику. Підтверди його — і ми не телефонуватимемо зайвий раз.';
    }
    var prev = doc.activeElement;
    setTimeout(function () { (state.typed ? go : input).focus(); }, 30);

    function close() {
      if (state.polling) { clearInterval(state.polling); state.polling = null; }
      doc.removeEventListener('keydown', onKey, true);
      if (bd.parentNode) bd.parentNode.removeChild(bd);
      if (prev && doc.contains(prev)) prev.focus();
    }
    // Escape and a tap outside mean «поверни мене в кошик», never «оформлюй».
    // They used to continue to the checkout, so the two gestures everyone uses
    // to cancel were the ones that committed (critique, 2026-09-21). Only the
    // two buttons in the sheet move her forward.
    function dismiss() {
      close();
      state.ask = true;                       // she has not answered: ask again on the next press
      if (onCancel) onCancel();               // and the checkout button stops looking busy
    }
    function onKey(e) { if (e.key === 'Escape') { e.preventDefault(); dismiss(); } }
    doc.addEventListener('keydown', onKey, true);

    function leave(phone) {
      close();
      // Back from Telegram on a phone, the page was frozen while she was away,
      // so «Чекаємо підтвердження» is still on screen for a moment after the bot
      // already confirmed her — and its button is «Пізніше, оформити
      // замовлення». Pressed then, it used to record a skip and open the
      // checkout without the confirmed number, so the order arrived with a phone
      // that matched nothing and stayed unconfirmed (owner, 2026-09-25). Waiting
      // worked only because the next poll caught the answer first. So a «later»
      // with a confirmation in flight looks once before throwing it away.
      if (!phone && state.token) {
        var token = state.token;
        var settled = false;
        var finish = function (j) {
          if (settled) return;
          settled = true;
          if (j) {
            state.phone = j.phone;
            saveAttributes(cartAttrs({ token: token, phone: j.phone }));
            afterSave(function () { done(j.phone); });
            return;
          }
          post('/api/cart-confirm/skip', { cart: state.ref });
          afterSave(function () { done(null); });
        };
        win.setTimeout(function () { finish(null); }, LOOKUP_WAIT_MS);
        lookup(token).then(finish);
        return;
      }
      if (!phone) post('/api/cart-confirm/skip', { cart: state.ref });
      afterSave(function () { done(phone); });
    }
    skip.addEventListener('click', function () { leave(null); });
    bd.addEventListener('click', function (e) { if (e.target === bd) dismiss(); });
    shut.addEventListener('click', dismiss);

    input.addEventListener('input', function () {
      var caretAtEnd = input.selectionStart === input.value.length;
      var v = pretty(input.value);
      if (v !== input.value) { input.value = v; if (caretAtEnd) input.setSelectionRange(v.length, v.length); }
      if (err.textContent) { err.textContent = ''; input.removeAttribute('aria-invalid'); }
    });

    function waiting(link, shared) {
      w.replaceChildren();
      var h2 = el('h2', 'hs-tg__h', 'Чекаємо підтвердження');
      h2.id = 'hs-tg-h';
      w.appendChild(h2);
      var dots = el('div', 'hs-tg__dots');
      dots.setAttribute('aria-hidden', 'true');
      dots.appendChild(el('span', 'hs-tg__dot'));
      dots.appendChild(el('span', 'hs-tg__dot'));
      dots.appendChild(el('span', 'hs-tg__dot'));
      w.appendChild(dots);
      w.appendChild(el('p', 'hs-tg__p', shared
        ? 'Надішли посилання людині, для якої замовлення, — вона натисне «Підтвердити номером телефону». Ця сторінка оновиться сама. Можеш оформлювати вже зараз: підтвердження дійде й потім.'
        : 'Відкрий бота й натисни «Підтвердити номером телефону». Ця сторінка оновиться сама.'));
      var again = el('a', 'hs-tg__b hs-tg__b--go', shared ? 'Надіслати посилання ще раз' : 'Відкрити Telegram ще раз');
      again.href = link;
      again.target = '_blank';
      again.rel = 'noopener';
      if (shared) {
        again.addEventListener('click', function (e) { e.preventDefault(); shareLink(link); });
      }
      w.appendChild(again);
      var later = el('button', 'hs-tg__b hs-tg__b--skip', 'Пізніше, оформити замовлення');
      later.type = 'button';
      later.addEventListener('click', function () { leave(null); });
      w.appendChild(later);
    }

    function confirmed(phone, changed) {
      w.replaceChildren();
      var h3 = el('h2', 'hs-tg__h', 'Номер підтверджено');
      h3.id = 'hs-tg-h';
      w.appendChild(h3);
      var okRow = el('p', 'hs-tg__ok');
      var tick = el('span', 'hs-tg__tick', '✓');
      tick.setAttribute('aria-hidden', 'true');
      okRow.appendChild(tick);
      okRow.appendChild(el('span', null, intlPretty(phone)));
      // The cart field, the order attributes and the checkout link all follow
      // the confirmed number, so nothing on the order says something else.
      try { if (win.HSNPLive && win.HSNPLive.setContact) win.HSNPLive.setContact({ phone: intl(phone) || phone }); } catch (e) { /* the cart field is a convenience, never a blocker */ }
      w.appendChild(okRow);
      if (changed) w.appendChild(el('p', 'hs-tg__p', 'Саме цей номер підставимо в замовлення — на нього телефонуватиме кур\'єр.'));
      var next = el('button', 'hs-tg__b hs-tg__b--go', 'Оформити замовлення');
      next.type = 'button';
      // Pressed at once or left to open by itself, the checkout is reached the
      // same way: once, and not before the confirmed number is on the cart.
      var going = false;
      var goNow = function () {
        if (going) return;
        going = true;
        next.disabled = true;
        afterSave(function () { close(); done(phone); });
      };
      next.addEventListener('click', goNow);
      w.appendChild(next);
      setTimeout(function () { next.focus(); }, 30);
      // She does not have to press anything: the checkout opens by itself.
      setTimeout(function () { if (doc.contains(bd)) goNow(); }, 2500);
    }

    function poll(token, link) {
      var started = Date.now();
      var tick = function () {
        if (!state.polling) return;
        if (Date.now() - started > POLL_FOR_MS) { clearInterval(state.polling); state.polling = null; return; }
        lookup(token).then(function (j) {
          // A lost poll is retried by the next tick; a late one after the
          // popup closed changes nothing.
          if (!j || !state.polling) return;
          clearInterval(state.polling); state.polling = null;
          state.phone = j.phone;
          saveAttributes(cartAttrs({ token: token, phone: j.phone }));
          confirmed(j.phone, !!j.changed);
        });
      };
      state.polling = setInterval(tick, POLL_MS);
      // Coming back from Telegram: look at once instead of leaving the waiting
      // screen up until the next tick (a phone pauses timers in a hidden page).
      state.recheck = tick;
    }

    // The phone's own share sheet when it has one, the clipboard otherwise.
    function shareLink(link) {
      var text = 'Підтверди, будь ласка, свій номер для доставки HolyShape: ' + link;
      try {
        if (win.navigator && win.navigator.share) {
          win.navigator.share({ text: text }).catch(function () {});
          return true;
        }
      } catch (e) { /* fall through to the clipboard */ }
      try {
        if (win.navigator && win.navigator.clipboard && win.navigator.clipboard.writeText) {
          win.navigator.clipboard.writeText(link).catch(function () {});
          return true;
        }
      } catch (e) { /* fall through to the field */ }
      return false;
    }

    share.addEventListener('click', function () {
      share.disabled = true;
      share.textContent = 'Готуємо посилання…';
      post('/api/cart-confirm/start', { cart: state.ref, phone: digits9(input.value) || null, test: state.test }).then(function (j) {
        if (!j || !j.ok || !j.link) throw new Error((j && j.error) || 'Не вдалося');
        state.token = j.token;
        saveAttributes(cartAttrs({ token: j.token }));
        var ok = shareLink(j.link);
        waiting(j.link, true);
        poll(j.token, j.link);
        if (!ok) {
          // No clipboard (an old browser, or a page served over http): show the
          // link itself so it can be copied by hand.
          var box = el('input', 'hs-tg__in');
          box.readOnly = true;
          box.value = j.link;
          box.setAttribute('aria-label', 'Посилання для підтвердження');
          box.addEventListener('focus', function () { box.select(); });
          w.insertBefore(box, w.children[3] || null);
        } else {
          var said = el('p', 'hs-tg__note', 'Посилання скопійовано — надішли його у месенджері.');
          w.insertBefore(said, w.children[3] || null);
        }
      }).catch(function (e) {
        share.disabled = false;
        share.textContent = 'Скопіювати посилання';
        err.textContent = e.message === 'Не вдалося' ? 'Не вдалося створити посилання — спробуй ще раз.' : e.message;
      });
    });

    go.addEventListener('click', function () {
      var d = digits9(input.value);
      if (!d) {
        err.textContent = 'Вкажи номер у форматі 067 123 45 67.';
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      go.disabled = true;
      go.textContent = 'Відкриваємо Telegram…';
      post('/api/cart-confirm/start', { cart: state.ref, phone: d, test: state.test }).then(function (j) {
        if (!j || !j.ok || !j.link) throw new Error((j && j.error) || 'Не вдалося');
        state.token = j.token;
        saveAttributes(cartAttrs({ token: j.token }));
        waiting(j.link, false);
        poll(j.token, j.link);
        // A phone browser often refuses a tab opened after a request came back.
        // Then we go to Telegram in this tab instead: the app takes over, and
        // when she comes back the cart already knows the number is confirmed.
        // Only when nothing happened, though — on a phone win.open can return
        // nothing and still hand over to the app, and going there again would
        // send /start a second time (the bot would ask twice).
        var tab = null;
        try { tab = win.open(j.link, '_blank', 'noopener'); } catch (e) { tab = null; }
        if (!tab) {
          setTimeout(function () {
            var hidden = doc.visibilityState === 'hidden' || (doc.hasFocus && !doc.hasFocus());
            if (!hidden) win.location.href = j.link;
          }, 1200);
        }
      }).catch(function (e) {
        go.disabled = false;
        go.textContent = 'Підтвердити в Telegram';
        err.textContent = e.message === 'Не вдалося' ? 'Не вдалося відкрити бота — спробуй ще раз або оформлюй замовлення.' : e.message;
      });
    });
  }

  function cartAttrs(o) {
    var a = {};
    a[ATTRS.cart] = state.ref;
    a[ATTRS.arm] = state.arm;
    if (o && o.token) a[ATTRS.token] = o.token;
    if (o && o.phone) a[ATTRS.phone] = o.phone;
    return a;
  }

  // hs-np.js calls this instead of going to the checkout itself.
  function before(url, btn) {
    // She usually types her number after the page has loaded, so the cart field
    // is read here, when the popup is about to open — not once at boot.
    try {
      var live = win.HSNPLive && win.HSNPLive.getContact ? win.HSNPLive.getContact() : null;
      if (live && live.phone) state.typed = digits9(live.phone) || state.typed;
    } catch (e) { /* the popup works without the cart field */ }
    var go = function (phone) {
      if (btn) { btn.classList.remove('hs-np-busy'); btn.removeAttribute('aria-busy'); }
      win.location.href = withPhone(url, phone || state.phone);
    };
    var decide = function () {
      if (!state.ask) return go(null);
      state.ask = false;                     // one popup per press
      popup(go, function () { if (btn) { btn.classList.remove('hs-np-busy'); btn.removeAttribute('aria-busy'); } });
    };
    // Armed at load only when the cart already had something in it. Coming from
    // the drawer it is armed here — but the checkout never waits longer than
    // ARM_WAIT_MS for it, whatever the connection does.
    if (state.armed) return decide();
    var done = false;
    var once = function (fn) { return function () { if (done) return; done = true; fn(); }; };
    var timer = win.setTimeout(once(function () { go(null); }), ARM_WAIT_MS);
    var finish = once(function () { decide(); });
    arm().then(function () { win.clearTimeout(timer); finish(); }, function () { win.clearTimeout(timer); finish(); });
  }

  // The cart page opened with ?tg=1 always shows the popup — for testing it on
  // a phone, whichever half that cart is in. Such a cart is left out of the
  // comparison on the admin page.
  function testMode() {
    try { return /[?&]tg=1\b/.test(win.location.search || '') || (win.location.hash || '') === '#tg'; }
    catch (e) { return false; }
  }

  // Which half this cart is in, and whether to ask. Called when the page loads
  // and again when the checkout button is pressed: the usual way to buy is to
  // open a product page with an empty cart, add the item and check out from the
  // drawer, and then there was no cart to arm at load (owner, 2026-09-20 — the
  // popup never showed and the cart went straight to the checkout).
  function arm() {
    if (state.arming) return state.arming;
    state.arming = cartJson().then(function (cart) {
      state.ref = cartRef(cart && cart.token);
      // Nothing to ask about yet; the next press tries again.
      if (!state.ref || !(cart.item_count > 0)) return null;
      var known = (cart.attributes || {})[ATTRS.phone];
      if (known) state.phone = known;
      // Typed in the cart, not yet confirmed in Telegram: it prefills the
      // popup, it never replaces a confirmation.
      var live = null;
      try { live = win.HSNPLive && win.HSNPLive.getContact ? win.HSNPLive.getContact() : null; } catch (e) { live = null; }
      state.typed = digits9((live && live.phone) || (cart.attributes || {})._recipient_phone || '') || state.typed;
      state.test = testMode();
      return post('/api/cart-confirm/arm', { cart: state.ref, test: state.test }).then(function (j) {
        if (!j) return null;
        state.arm = j.arm || 'control';
        state.bot = j.bot || null;
        state.ask = !!j.ask && (state.test || !state.phone);
        if (j.confirmed && j.confirmed.phone) { state.phone = j.confirmed.phone; if (!state.test) state.ask = false; }
        state.armed = true;
        return null;
      });
    }).catch(function () { state.ask = false; })
      .then(function () { state.arming = null; return null; });
    return state.arming;
  }

  function init() {
    arm();
    // The tab comes back into view (she was in Telegram), or the page is restored
    // from the back/forward cache: an open confirmation is looked at right away.
    var back = function () { if (state.polling && state.recheck) state.recheck(); };
    try {
      doc.addEventListener('visibilitychange', function () { if (doc.visibilityState !== 'hidden') back(); });
      if (win.addEventListener) win.addEventListener('pageshow', back);
    } catch (e) { /* the regular poll still catches it */ }
  }

  // One object, not two: the wrapper at the top also assigns what this factory
  // returns to window.HSTG, so a second object here would overwrite `before`
  // and the cart would walk past the popup straight into the checkout.
  api.before = before;
  api.debug = function () { return { state: state }; };
  win.HSTG = api;
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();

  return api;
}));
